export default __webpack_public_path__ + "static/blit-stride-a04c6100837b88ff4f0221562e1dd8a5.png";